var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{ref:"mainRoute",on:{"closeChat2":_vm.closeChat2,"rerenderMainLayout":_vm.rerenderMainLayout}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }